import { Card, CardContent, Chip, Grid, Stack, TableCell, TableRow, Typography, alpha, useTheme } from '@mui/material';

import { convetToTitleCase, fNumber, getCurrencySymbol } from '@zeta-core';
import CommonTableLayout from './common-table-layout';

interface Props {
  section: string;
  clientPartnerDetails: any;
  summaryData: any;
}

const TotalCard = ({ title, value }: { title: string; value: string }) => {
  const theme = useTheme();

  return (
    <Grid container>
      <Grid
        size={{
          xs: 12,
          md: 6
        }}>
        <Card sx={{ background: alpha(theme.palette.grey[100], 1), border: 'none', boxShadow: '0px 1px 2px 0px rgba(145, 158, 171, 0.16)' }}>
          <CardContent
            component={Stack}
            gap={2}
            flexDirection="row"
            justifyContent="space-between"
            sx={{ p: 2, pb: '8px !important', pt: '8px !important' }}
            alignItems="center"
          >
            <Typography variant="subtitle1" id={title}>
              {title}
            </Typography>

            <Chip
              label={
                <Typography variant="chipLabel" id={`total-value`}>
                  {getCurrencySymbol('GBP')} {fNumber(value)}
                </Typography>
              }
              color="success"
              variant="soft"
            />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

const SummaryTabComponent = ({ section, clientPartnerDetails, summaryData }: Props) => {
  const FieldsHead = [
    { label: `${section} Belongs To`, width: '30%', show: true },
    { label: `Total ${section}`, width: '30%', show: true },
  ];

  return (
    <>
      <Grid container>
        <Grid
          size={{
            xs: 12,
            md: 6
          }}>
          <CommonTableLayout tableHead={FieldsHead} borderToBeGiven>
            <>
              <TableRow sx={{ borderBottom: `1px solid ${alpha('#919EAB', 0.16)} !important`, verticalAlign: 'top' }}>
                <TableCell>
                  <Typography
                    variant="caption"
                    id="summary-client-name"
                    color="text.secondary"
                    sx={{ py: 2.063, px: 1.75, display: 'flex', alignItems: 'center' }}
                  >
                    {convetToTitleCase(clientPartnerDetails?.clientDetail?.title)} {clientPartnerDetails?.clientDetail?.name || 'Client'}
                  </Typography>
                </TableCell>

                <TableCell>
                  <Typography
                    variant="caption"
                    id="summary-client-total-income"
                    color="text.primary"
                    sx={{ py: 2.063, px: 1.75, display: 'flex', alignItems: 'center', justifyContent: 'end' }}
                  >
                    {getCurrencySymbol('GBP')} {fNumber(summaryData?.totalClientValue)}
                  </Typography>
                </TableCell>
              </TableRow>

              <TableRow sx={{ borderBottom: `1px solid ${alpha('#919EAB', 0.16)} !important`, verticalAlign: 'top' }}>
                <TableCell>
                  <Typography variant="caption" id="summary-partner" color="text.secondary" sx={{ py: 2.063, px: 1.75, display: 'flex', alignItems: 'center' }}>
                    {convetToTitleCase(clientPartnerDetails?.partnerDetail?.title)} {clientPartnerDetails?.partnerDetail?.name || 'Partner'}
                  </Typography>
                </TableCell>

                <TableCell>
                  <Typography
                    variant="caption"
                    id="summary-partner-income"
                    color="text.primary"
                    sx={{ py: 2.063, px: 1.75, display: 'flex', alignItems: 'center', justifyContent: 'end' }}
                  >
                    {getCurrencySymbol('GBP')} {fNumber(summaryData?.totalPartnerValue)}
                  </Typography>
                </TableCell>
              </TableRow>

              <TableRow sx={{ borderBottom: `1px solid ${alpha('#919EAB', 0.16)} !important`, verticalAlign: 'top' }}>
                <TableCell>
                  <Typography variant="caption" id="summary-joint" color="text.secondary" sx={{ py: 2.063, px: 1.75, display: 'flex', alignItems: 'center' }}>
                    {'Joint'}
                  </Typography>
                </TableCell>

                <TableCell>
                  <Typography
                    variant="caption"
                    id="summary-joint-income"
                    color="text.primary"
                    sx={{ py: 2.063, px: 1.75, display: 'flex', alignItems: 'center', justifyContent: 'end' }}
                  >
                    {getCurrencySymbol('GBP')} {fNumber(summaryData?.totalJointValue)}
                  </Typography>
                </TableCell>
              </TableRow>
            </>
          </CommonTableLayout>
        </Grid>
      </Grid>
      {(section === 'Income' || section === 'Expenditure') && (
        <>
          <TotalCard title={`Total ${section} - Monthly`} value={`${summaryData?.totalMonthly}`} />
          <TotalCard title={`Total ${section} - Annually`} value={`${summaryData?.totalAnnualy}`} />
        </>
      )}
      {(section === 'Assets' || section === 'Liabilities') && <TotalCard title={`Total ${section}`} value={`${summaryData?.total}`} />}
    </>
  );
};

export default SummaryTabComponent;
